
export default {
  name: 'Loading',
  props: ['time']
}